import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const PROJECT_RESOURCE_ALLOCATION_ACTIONS_QUERY = gql`
  query GetProjectResourceAllocationActions($projectId: String) {
    project(projectId: $projectId) {
      id
      resourceAllocationActions {
        canViewResourceAllocation
        canEditResourceAllocation
      }
    }
  }
`;

const useProjectResourceAllocationActions = ({ projectId, skip }) => {
  const { loading, data } = useQuery(
    PROJECT_RESOURCE_ALLOCATION_ACTIONS_QUERY,
    {
      variables: { projectId },
      skip
    }
  );

  return {
    loading,
    resourceAllocationActions: data?.project?.resourceAllocationActions
  };
};

export default useProjectResourceAllocationActions;
